/** @jsx jsx */
import { useTranslation } from 'react-i18next';
import { jsx, Box } from 'theme-ui';

export default ({ servicePoint: s, isSelected, onSelect, ...props }) => {
  const { t: translate } = useTranslation();
  const translateAgent = (s) => s && s.replace('MH-asiamies', translate('buyParcel.pickup.agent'));
  const hasAddress = !!(s.officeStreetAddress || s.officePostalCode || s.officeCity);
  return (
    <Box
      {...props}
      sx={{
        py: 12,
        px: 3,
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        bg: isSelected ? 'primary' : 'white',
        color: isSelected ? 'white' : 'text',
        cursor: 'pointer',
        lineHeight: 'heading',
        ':first-of-type': {
          border: 0,
        },
        '& + div': {
          borderTopColor: isSelected ? 'transparent' : 'border',
        },
        ':hover': {
          bg: isSelected ? 'primary' : 'blueLighter',
        },
      }}
      onClick={onSelect}
    >
      <Box sx={{ fontWeight: 'medium' }}>{translateAgent(s.officeName)}</Box>
      {hasAddress && (
        <Box>
          {s.officeStreetAddress}, {s.officePostalCode} {s.officeCity}
        </Box>
      )}
    </Box>
  );
};
